module.exports = __webpack_public_path__ + "img/star.642a4fcb.svg";